module.exports = __webpack_public_path__ + "6e22f80750670138993166e724c0864d.png";